import Icon from './Icon';
import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function MidCta() {
  return (
    <section className="mid-cta">
      <div className="shell mid-cta__inner">
        <div className="mid-cta__copy">
          <p className="kicker">Talk to an expert</p>
          <h2>Need it sorted right now?</h2>
          <p>
            Skip the wait. Call or chat and walk through the error with an expert — most cases are
            picked up the same day.
          </p>
        </div>
        <div className="mid-cta__actions">
          <a href={SUPPORT_PHONE_TEL} className="btn btn--green">
            <Icon name="phone" size={18} />
            Call {SUPPORT_PHONE_LABEL}
          </a>
          <button type="button" className="btn btn--green-line" onClick={openZohoChat}>
            <Icon name="chat" size={18} />
            Start live chat
          </button>
          <a href="#consultation" className="btn btn--quiet">
            Book a callback
          </a>
        </div>
      </div>
    </section>
  );
}
